module.exports = __webpack_public_path__ + "static/media/payroll-users.f90fbc42.svg";